<header>
    <div class="header-container d-flex">
        <div class="menu-container">
        </div>
        <div class="header-right">
            <button class="header-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-bell-fill" viewBox="0 0 16 16">
                    <path
                        d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2m.995-14.901a1 1 0 1 0-1.99 0A5 5 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901" />
                </svg>
            </button>

            <div ngbDropdown class="d-inline-block" *ngIf="user">
                <button ngbDropdownToggle *ngIf="user != null" class="header-button profile-button">
                    <ng-container>{{userSymbol}}</ng-container>
                </button>
                <div ngbDropdownMenu>
                    <div id="menuWrap">
                        <div class="header-button profile-button d-flex">
                            <ng-container>{{userSymbol}}</ng-container>
                        </div>
                        <div>
                            <div>
                                <b>{{user.name}}</b>
                                <p>{{user.organisation.name}}</p>
                            </div>
                        </div>
                    </div>
                    <button (click)="openProfile()" ngbDropdownItem>Mijn profiel</button>
                    <button (click)="logout()" ngbDropdownItem>Uitloggen</button>
                </div>
            </div>

        </div>
    </div>
</header>